"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOrderTypeToString = transformOrderTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
// duplicate transformOrderTypeToDisplayString
function transformOrderTypeToString(orderType) {
    switch (orderType) {
        case legacy_enums_1.OrderType.Private:
            return "private";
        case legacy_enums_1.OrderType.Shared:
            return "pool";
        default:
            return "";
    }
}
//# sourceMappingURL=transformOrderTypeToString.js.map